module.exports = __webpack_public_path__ + "8bc6d815c5757e933aead726688d4511.pdf";